module.exports = __webpack_public_path__ + "static/media/clue-3.e76d00f3.svg";